// Carousel
// HTML:    https://vrendle.test/res/behandelingen.html 

import $ from 'jquery';

var carousel = $('.c-carousel');
var carouselNext = $('.c-carousel__next');
var carouselPrev = $('.c-carousel__prev');
var carouselItem = $('.c-carousel__item');


$(document).ready(function() {
    removeArrows();
});

function removeArrows (){      // Remove Arrows and Shadows when this isn't needed.

    $(carousel).each(function(){
        const carouselWidth = $(carousel).outerWidth();
        const carouselItemWidth = $(carouselItem).outerWidth();
        const carouselItemCount = $(this).children('.c-carousel__item').length;

        if (carouselItemWidth * carouselItemCount < carouselWidth ) {
            $(this).find(carouselNext).hide();
            $(this).removeClass('c-carousel--after');
        }
    });
}

$(carousel).scroll( function() {
 
    var carouselActive = $(this);
    
    var carouselWidth = $(carouselActive).outerWidth();
    var scrollWidth = $(carouselActive)[0].scrollWidth;
    var scrollLeft = $(carouselActive).scrollLeft();

    if (scrollLeft === 0) {
        $(carouselActive).removeClass('c-carousel--before');
        $(carouselActive).find(carouselPrev).hide();
    } else {
    	$(carouselActive).addClass('c-carousel--before');
    	$(carouselActive).find(carouselPrev).show();
    }
    if (scrollWidth - carouselWidth === scrollLeft) {
        $(carouselActive).removeClass('c-carousel--after');
        $(carouselActive).find(carouselNext).hide();
    } else {
    	$(carouselActive).addClass('c-carousel--after');
    	$(carouselActive).find(carouselNext).show();
    }
});

$(carouselNext).on('click', function() {
    var carouselActive = $(this).closest(carousel);
    var carouselItem = $(carouselActive).find('.c-carousel__item');
    var carouselItemWidth = $(carouselItem).outerWidth(true);

    $(carouselActive).animate({
        scrollLeft: '+=' + carouselItemWidth
    }, 300);
});

$(carouselPrev).on('click', function() {
    var carouselActive = $(this).closest(carousel);
    var carouselItem = $(carouselActive).find('.c-carousel__item');
    var carouselItemWidth = $(carouselItem).outerWidth(true);

    $(carouselActive).animate({
        scrollLeft: '-=' + carouselItemWidth
    }, 300);
});